import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import {Scrollbars} from 'react-custom-scrollbars';

import Tenant from './../tenant';
import {pageInitializationStatus} from './../../consts';
import {entityFetcher} from './../../utils/entityFetcher';
import {getMessage} from './../../utils/i18n';
import {getIconClass} from './../../utils/icons';
import Loading from './../loading';
import Error from './../error';
import ChangePassword from './../../containers/changePassword';
import ChangeLanguage from './../../containers/changeLanguage';

import './home.css';

class Home extends Component {

    constructor(props) {
        super(props);
        this.state = {
            pageStatus: pageInitializationStatus.START,
            data: [],
            errorStatus: null
        };
        this.pendingRequests = {};
    }

    registerRequest(token) {
        token = token ? token : new Date().getTime();
        return (cancelFunc) => {
            Object.assign(this.pendingRequests, {[token]: cancelFunc});
        };
    };

    cancelPendingRequests() {
        Object.keys(this.pendingRequests).forEach((token) => {
            this.pendingRequests[token]();
            delete this.pendingRequests[token];
        });
    };

    initialize() {
        const requestToken = new Date().getTime();
        const fetcher = entityFetcher.read({
            api: 'fo/me/tenants',
            params: {},
            cancelToken: this.registerRequest(requestToken)
        });
        fetcher.then(
            json => {
                delete this.pendingRequests[requestToken];
                this.setState({
                    pageStatus: pageInitializationStatus.SUCCESS,
                    data: json
                })
            },
            e => {
                delete this.pendingRequests[requestToken];
                this.setState({
                    pageStatus: pageInitializationStatus.FAIL,
                    errorStatus: (e.response || {}).status
                })
            }
        );
    }

    renderThumb({style, ...props}) {
        return (
            <div className="foThumb"
                 style={{...style, width: 8}}
                 {...props}/>
        );
    }

    componentWillMount() {
        this.initialize();
    }

    componentWillUnmount() {
        this.cancelPendingRequests();
    }

    render() {
        const {pageStatus, data, errorStatus} = this.state;
        const boUrl = data.boUrl;
        const tenantList = (data.tenants || {}).entities;
        const managedTenants = data.managedTenants || [];
        return (
            <Scrollbars className="foMain"
                        style={{height:"calc(100% - 30px)"}}
                        renderThumbVertical={this.renderThumb}
                        renderThumbHorizontal={this.renderThumb}
            >
                {
                    pageStatus === pageInitializationStatus.START && <Loading/>
                }
                {
                    pageStatus === pageInitializationStatus.FAIL && <Error errorStatus={errorStatus}/>
                }
                {
                    pageStatus === pageInitializationStatus.SUCCESS && (
                        boUrl &&
                        <div className="foSuiteModuleWrapper">
                            <span className="foSuiteModuleTitle">{getMessage('module.suitesAdministration')}</span>
                            <div className="foSuiteModule">
                                <div className="foSiteContainer">
                                    <div className={`foSiteLogo_ITSMA-X`}/>
                                    <div className="foSiteContent">
                                        <div className="foSiteHeader">
                                            <div className="foSiteTitle">
                                                {getMessage("suite-admin.title")}
                                            </div>
                                        </div>
                                        <div className="foSiteSecondLine">
                                        <span className="foSiteAttributeGroup">
                                            <span className="foSiteAttribute">
                                                <span className="foSiteAttributeName">
                                                    {getMessage("tenant.attribute-name.url")}
                                                </span>
                                                <span id="foSiteUrl-bo"
                                                      className="foSiteAttributeValue">
                                                   {boUrl}
                                                </span>
                                            </span>
                                            <span className={"foSiteCopyUrl foClipboard " + getIconClass("copy")}
                                                  title={getMessage('tenant.copy-link')}
                                                  data-clipboard-target={`#foSiteUrl-bo`}/>
                                        </span>
                                            <a className="foSiteLink"
                                               href={boUrl}
                                               target="_blank"
                                               rel="noopener noreferrer"
                                            >
                                                {getMessage('app.action.enter-tenant')}
                                            </a>
                                        </div>
                                        <div className="foSiteDescription">
                                            {getMessage("suite-admin.description")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
                {
                    pageStatus === pageInitializationStatus.SUCCESS &&
                    <div className="foSuiteModuleWrapper">
                        <span className="foSuiteModuleTitle">{getMessage('module.tenants')}</span>
                        <div className="foSuiteModule">
                            {
                                tenantList instanceof Array && tenantList.length > 0 ?
                                    tenantList.map((tenant, index) => {
                                        const mspManaged = managedTenants.includes(String(tenant.id))? 'true' : 'false';
                                        return <Tenant index={index} tenant={tenant} mspManaged={mspManaged}
                                                       key={`fo-tenant-list-${index}`}/>
                                    }) :
                                    <div className="foNoSiteAvailableNotification">
                                        {getMessage("tenant.no-tenant")}
                                    </div>
                            }
                        </div>
                    </div>
                }
                <Route path="/changePassword" component={ChangePassword}/>
                <Route path="/changeLanguage" component={ChangeLanguage}/>
            </Scrollbars>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/app/components/home/index.js